import { c as _c } from "react/compiler-runtime";
import { FormControlLabel, type FormControlLabelProps, ListItem } from '@mui/material';
export function FormLabeledListItem(t0) {
  const $ = _c(6);
  const {
    control,
    label,
    value
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      paddingX: 3,
      paddingY: 2
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      color: "text.secondary",
      marginLeft: 0,
      flex: 1,
      justifyContent: "space-between",
      "& span:last-child": {
        fontSize: 14
      }
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== control || $[3] !== label || $[4] !== value) {
    t3 = <ListItem sx={t1}><FormControlLabel control={control} label={label} value={value} labelPlacement="start" sx={t2} /></ListItem>;
    $[2] = control;
    $[3] = label;
    $[4] = value;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}